module.exports = __webpack_public_path__ + "img/704c6537d9c6abd0fc7fb65edc22078.abe67712.jpg";